import dayjs from "dayjs";

const times = [
  ["06-03", "06-05"],
  ["09-30", "10-07"],
];

export default function isDuringSpecial() {
  return times.some((time) => {
    const now = dayjs();
    const year = now.format("YYYY");
    return (
      now.isAfter(dayjs(`${year}-${time[0]}`, "YYYY-MM-DD")) &&
      now.isBefore(dayjs(`${year}-${time[1]}`, "YYYY-MM-DD").add(1, "day"))
    );
  });
}
